import { Controller } from "@hotwired/stimulus"

const THEME_COLORS = {
  default: { light: null, dark: null },
  boulder: { light: "#1849A9", dark: "#ADD6FF" },
  colorado: { light: "#701C1C", dark: "#E59AA5" },
  durango: { light: "#DA3B01", dark: "#F4BFAB" },
  golden: { light: "#B35600", dark: "#FFDDB3" },
  steamboat: { light: "#335C67", dark: "#9DC4CF" },
  foco: { light: "#770198", dark: "#EEB4FE" },
  pitkin: { light: "#063B06", dark: "#C5E5C5" },
  sterling: { light: "#E0E0E0", dark: "#383838" },
}

export default class extends Controller {
  static values = { themeColors: Array }

  connect() {
    this.defaultLight = getComputedStyle(document.documentElement).getPropertyValue("--primary").trim()
    this.defaultDark = getComputedStyle(document.documentElement).getPropertyValue("--primaryl1").trim()

    if (this.hasThemeColorsValue && this.themeColorsValue.length > 0) {
      const defaultEntry = this.themeColorsValue.find(t => t.key === "default")
      if (defaultEntry) {
        THEME_COLORS.default.light = defaultEntry.color
        THEME_COLORS.default.dark = this.defaultDark
      }
    }
  }

  updateAppearance() {
    const selected = this.element.querySelector('input[name="appearance"]:checked')
    if (!selected) return

    if (selected.value === "dark") {
      document.body.classList.add("dark-portal")
    } else {
      document.body.classList.remove("dark-portal")
    }
  }

  updateTheme() {
    const selected = this.element.querySelector('input[name="theme"]:checked')
    if (!selected) return

    const key = selected.value
    const colors = THEME_COLORS[key]

    document.body.className = document.body.className.replace(/\b(boulder|colorado|durango|golden|steamboat|foco|pitkin|sterling|default)\b/g, "").trim()
    if (key !== "default") {
      document.body.classList.add(key)
    }

    if (colors) {
      const light = colors.light || this.defaultLight
      const dark = colors.dark || this.defaultDark
      document.documentElement.style.setProperty("--primary", light)
      document.documentElement.style.setProperty("--primaryl1", dark)
    }
  }
}
